"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_relay_1 = require("react-relay");

var relay_runtime_1 = require("relay-runtime");

var RelayEnvironmentProvider = function RelayEnvironmentProvider(props) {
  relay_runtime_1.RelayFeatureFlags.PREFER_FRAGMENT_OWNER_OVER_CONTEXT = true;
  return React.createElement(react_relay_1.ReactRelayContext.Provider, {
    value: {
      environment: props.environment,
      variables: {}
    }
  }, props.children);
};

exports.default = RelayEnvironmentProvider;